/**
 * Express Payment Methods Hook for v2 Architecture
 * Uses the ExpressPaymentMethodsProvider context
 */

import { useContext } from 'react';
import { ExpressPaymentMethodsContext, ExpressPaymentMethodsContextType } from '../providers/ExpressPaymentMethodsProvider';

/**
 * Hook to access Express Payment Methods context
 * Must be used within an ExpressPaymentMethodsProvider
 */
export const useExpressPaymentMethods = (): ExpressPaymentMethodsContextType => {
    const context = useContext(ExpressPaymentMethodsContext);
    if (context === undefined) {
        throw new Error('useExpressPaymentMethods must be used within an ExpressPaymentMethodsProvider');
    }
    return context;
};

// Re-export types for convenience
export type {
    ExpressPaymentMethodsContextType,
    ExpressPaymentMethodsProviderProps
} from '../providers/ExpressPaymentMethodsProvider';

export type {
    Address,
    PaymentMethod
} from '../../core/resources/expressPaymentMethods';

